import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from 'src/components/ui/label';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/ui/select';
import { usePreferences } from 'src/hooks/usePreferences';
import { PageLayout } from 'src/layouts/PageLayout';

export function PreferencesDefaultPage(): ReactElement {
  const { t } = useTranslation('preferences');
  const { language, setLanguage } = usePreferences();

  return (
    <PageLayout title={t('Preferences')}>
      <div className='flex flex-col gap-8'>
        <div className='grid grid-cols-2 gap-4 p-6'>
          <div className='flex flex-col gap-1'>
            <span className='font-semibold text-lg'>{t('Application')}</span>
            <span className='text-layout-foreground-secondary text-sm'>
              {t('Change the application settings')}
            </span>
          </div>
          <div className='col-span-1 flex w-full flex-col gap-8 pr-14 font-medium text-sm'>
            <div className='flex flex-col gap-2'>
              <Label>{t('Language')}</Label>
              <Select
                onValueChange={(value) => setLanguage(value)}
                value={language}
              >
                <SelectTrigger className='w-full capitalize'>
                  <SelectValue placeholder='Français' />
                </SelectTrigger>
                <SelectContent defaultValue={language}>
                  <SelectGroup>
                    <SelectItem className='capitalize' value='fr'>
                      Français
                    </SelectItem>
                    <SelectItem className='capitalize' value='en'>
                      English
                    </SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
